import React from 'react';

function Error(props) {
	return <p className='form-control-error'>{props.error}</p>;
}

export default Error;
